"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDbarState = void 0;
var DbarState_1 = require("@/pages/developments/states/dbar/DbarState");
exports.defaultDbarState = {
    sortAction: { name: 'Sort' },
    filterAction: { name: 'Filter' },
    opened: DbarState_1.DbarPops.NONE,
};
